if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        document.documentElement.classList.remove("overflow-hidden");
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      resolveOpenedMediaId() {
        const opener = this.openedBy;
        if (!opener) return null;

        if (opener.getAttribute) {
          const ownId = opener.getAttribute("data-media-id");
          if (ownId) return ownId;
        }

        if (opener.closest) {
          const closest = opener.closest("[data-media-id]");
          if (closest) {
            const closestId = closest.getAttribute("data-media-id");
            if (closestId) return closestId;
          }
        }

        if (opener.querySelector) {
          const nested = opener.querySelector("[data-media-id]");
          if (nested) {
            const nestedId = nested.getAttribute("data-media-id");
            if (nestedId) return nestedId;
          }
        }

        return null;
      }

      showActiveMedia() {
        document.documentElement.classList.add("overflow-hidden");

        const mediaId = this.resolveOpenedMediaId();

        this.querySelectorAll("[data-media-id]").forEach((element) => {
          element.classList.remove("active");
        });

        let activeMedia = mediaId
          ? this.querySelector(`[data-media-id="${mediaId}"]`)
          : null;

        if (!activeMedia) {
          activeMedia =
            this.querySelector(".product-media-modal__content > [data-media-id]") ||
            this.querySelector(".product-media-modal__content > *");
        }

        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector("template");
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;
        activeMedia.classList.add("active");
        activeMedia.scrollIntoView();

        const activeImage =
          activeMedia.nodeName === "IMG"
            ? activeMedia
            : activeMedia.querySelector("img");
        if (activeImage) {
          activeImage.loading = "eager";
          activeImage.setAttribute("loading", "eager");
        }

        const container = this.querySelector('[role="document"]');
        if (container && activeMedia.width) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == "DEFERRED-MEDIA" &&
          activeMediaContent &&
          activeMediaContent.querySelector(".js-youtube")
        )
          activeMedia.loadContent();
      }
    },
  );
}
